import { Button, Form, Input, Select } from 'antd';
import { useRef, useState } from 'react';
import { usePosts } from './PostsState';
import TextEditor from '../../../Components/Macro/TextEditor/TextEditor';
import ImgUpload from '../../../Components/Macro/ImgUpload/ImgUpload';
import FileUpload from '../../../Components/Macro/ImgUpload/FileUpload';

function Add() {
    const formRef = useRef();
    let { addPost } = usePosts()
    let [userImg, setUserImg] = useState('');
    let [body, setBody] = useState('')
    let [pdf, setPdf] = useState('')

    const handleFinish = (values) => {
        addPost({ title: values.title, img: userImg, body: body, pdf: pdf, category: values.category });
        formRef.current?.resetFields();
        setUserImg('');
        setBody('');
        setPdf('');
    }

    return (
        <div>
            <Form
                ref={formRef}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={handleFinish}
            >
                <Form.Item
                    name={"title"}
                    label="Sarlavha"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name={'img'}
                    label="Asosiy Rasm"
                >
                    <ImgUpload userImg={userImg} setUserImg={setUserImg} />
                </Form.Item>

                <Form.Item
                    name={'pdf'}
                    label="Maqola PDF fayli"
                >
                    <FileUpload setUserImg={setPdf} />
                </Form.Item>
                <Form.Item name={'category'} label="Kategoriya">
                    <Select options={[{ value: 'Qaror', label: 'Qaror' }, { value: 'Maqola', label: 'Maqola' }]} />
                </Form.Item>
                <Form.Item name={"body"} label="Maqola">
                    <TextEditor height={'550px'} onChange={setBody} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Saqlash</Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default Add;